// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"cb019f1b","248":"f721c5c2"}[chunkId] + ".chunk.js";
};